import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import DepositModal from '../DepositModal';
import BuyModal from '../BuyModal';
import WithdrawModal from '../WithdrawModal';
import SendCryptoModal from '../SendCryptoModal';
import ProptPrice from '../ProptPrice';
import { useProptPrice } from '../../hooks/useProptPrice';

const DashboardValidated = ({ balances: propBalances }) => {
   const proptPrice = useProptPrice();
   const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);
   const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
   const [initialStep, setInitialStep] = useState(1);
   const [selectedCrypto, setSelectedCrypto] = useState(null);
   const [isBuyModalOpen, setIsBuyModalOpen] = useState(false);
   const [selectedCryptoForBuy, setSelectedCryptoForBuy] = useState(null);
   const [selectedCryptoForWithdraw, setSelectedCryptoForWithdraw] = useState(null);
   const [isSendModalOpen, setIsSendModalOpen] = useState(false);
   // const [showMore, setShowMore] = useState(false);
   const [apiBalances, setApiBalances] = useState({});
   const [walletData, setWalletData] = useState([]);
   const [percentages, setPercentages] = useState({});
   const [totalBalance, setTotalBalance] = useState(0);
   const [isLoading, setIsLoading] = useState(true);
   const [withdrawInitialStep, setWithdrawInitialStep] = useState(1);

   // para precio propt estable
   const [rates, setRates] = useState(null);

   // Información de las criptomonedas soportadas
   const cryptoInfo = {
      USD: {
         name: 'US Dollar',
         image: '/assets/img/icon_dollar.svg',
         fullName: 'US Dollar',
         fixedPrice: 1.00
      },
      USDC: {
         name: 'USDC',
         image: '/assets/img/icon_usdc.svg',
         fullName: 'USD Coin',
         fixedPrice: 1.00
      },
      USDT: {
         name: 'USDT',
         image: '/assets/img/icon_usdt.svg',
         fullName: 'Tether',
         fixedPrice: 1.00
      },
      BTC: {
         name: 'BTC',
         image: '/assets/img/icon_btc.svg',
         fullName: 'Bitcoin'
      },
      ETH: {
         name: 'ETH',
         image: '/assets/img/icon_eth.svg',
         fullName: 'Ethereum'
      },
      MATIC: {
         name: 'MATIC',
         image: '/assets/img/icon_pol.svg',
         fullName: 'Polygon'
      },
      POL: {
         name: 'POL',
         image: '/assets/img/icon_pol.svg',
         fullName: 'Polygon'
      },
      PROPT: {
         name: 'PROPT',
         image: '/assets/img/icon_propt_n.svg',
         fullName: 'ProperT',
         fixedPrice: 0.22
      },
      'PROPT-ETH': {
         name: 'PROPT-ETH',
         image: '/assets/img/icon_propt_n.svg',
         fullName: 'ProperT (Ethereum)',
      },
      'PROPT-POL': {
         name: 'PROPT-POL',
         image: '/assets/img/icon_propt_n.svg',
         fullName: 'ProperT (Polygon)',
      }
   };

   // Función para obtener color predeterminado para cada criptomoneda
   const getCryptoColor = (currency) => {
      const defaultColors = {
         BTC: '#f7931a',
         ETH: '#627eea',
         USDT: '#26a17b',
         USDC: '#2775ca',
         PROPT: '#e4dc00',
         MATIC: '#8247e5',
         POL: '#8247e5',
         USD: '#85bb65'
      };

      return defaultColors[currency] || '#3ad1b7';
   };

   useEffect(() => {
      // 1. Salimos si los datos básicos aún no han cargado.
      if (walletData.length === 0 || !proptPrice || proptPrice <= 0) {
         return;
      }

      console.log(`Recalculando TODO con PROPT price: ${proptPrice}`);

      // --- PASO 1: Calcular el balance total correcto ---
      let calculatedTotalBalance = 0;
      const individualValues = {}; // Objeto para guardar los valores individuales en USD

      walletData.forEach(wallet => {
         let valueInUSD = parseFloat(wallet.currencyToUSD || 0);

         // Usamos nuestra lógica especial para los PROPT
         if (wallet.currency.startsWith('PROPT')) {
            valueInUSD = parseFloat(wallet.amount) * proptPrice;
         }

         individualValues[wallet.currency] = valueInUSD; // Guardamos el valor calculado
         calculatedTotalBalance += valueInUSD; // Lo sumamos al total
      });

      // Actualizamos el estado del balance con nuestro cálculo correcto
      setTotalBalance(calculatedTotalBalance);

      // --- PASO 2: Calcular los porcentajes usando el nuevo total ---
      const calculatedPercents = {};
      if (calculatedTotalBalance > 0) {
         for (const currency in individualValues) {
            const value = individualValues[currency];
            const percent = (value / calculatedTotalBalance) * 100;
            calculatedPercents[currency] = isNaN(percent) ? 0 : parseFloat(percent.toFixed(2));
         }
      }

      setPercentages(calculatedPercents);

   }, [walletData, proptPrice, totalBalance]); // <-- DEPENDENCIAS CLAVE
   // }, [walletData, proptPrice]); // <-- Las dependencias siguen siendo las mismas

   // const response = await fetch('https://pt-api.digit-a.net/api/wallets/get-general-balance', {
   //    method: 'GET',
   //    headers: {
   //       'Authorization': `Bearer ${jwt}`,
   //       'Content-Type': 'application/json'
   //    }
   // });
   // Función para obtener los balances de la API
   const fetchBalances = async () => {
      try {
         const jwt = localStorage.getItem('jwt');
         if (!jwt) return;

         // No es necesario setIsLoading(true) aquí si ya está en el otro useEffect
         // setIsLoading(true);

         const response = await fetch('https://pt-api.digit-a.net/api/wallets/get-general-balance', {
            method: 'GET',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            }
         });
         if (!response.ok) throw new Error('Failed to fetch balances');

         const data = await response.json();
         console.log('API Balances:', data);

         // --- LÓGICA SIMPLIFICADA ---
         // Simplemente guardamos los datos crudos de la API.
         // El nuevo useEffect se encargará de los cálculos.
         setWalletData(data.wallets || []);
         setTotalBalance(data.balance || 0);

         const balanceObj = {};
         (data.wallets || []).forEach(wallet => {
            balanceObj[wallet.currency] = parseFloat(wallet.amount || 0);
         });
         setApiBalances(balanceObj);
         // --- YA NO CALCULAMOS PORCENTAJES AQUÍ ---

      } catch (error) {
         console.error('Error fetching balances:', error);
      } finally {
         // setIsLoading(false); // Puede que quieras manejar el loading de otra forma
      }


   };

   // Cargar los datos al montar el componente
   useEffect(() => {
      localStorage.removeItem('mnemonicPhrase')
      fetchBalances();

      // Actualización periódica cada 30 segundos
      const interval = setInterval(() => {
         fetchBalances();
      }, 30000);

      return () => clearInterval(interval);
   }, []);

   // Funciones de manejo de eventos (sin cambios)
   const handleDepositClick = (e) => {
      e.preventDefault();
      setIsDepositModalOpen(true);
   };

   const handleDepositUSDClick = () => {
      setInitialStep(2);
      setIsDepositModalOpen(true);
   };

   // Actualizar la función handleCryptoDeposit para incluir la llamada a la API
   const handleCryptoDeposit = async (cryptoName, imagePath, currencyCode) => {
      try {
         // Mostrar estado de carga
         setIsLoading(true);

         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }

         // Llamar a la API para obtener información de depósito
         const response = await fetch(`https://pt-api.digit-a.net/api/deposit/deposit-coin/select-currency/${currencyCode === "PROPT-POLYGON" ? "PROPT-POL" : currencyCode === "PROPT-ETHEREUM" ? "PROPT-ETH" : currencyCode}`, {
            method: 'GET',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            }
         });

         if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
         }

         const data = await response.json();
         console.log('Currency deposit info:', data);

         // Configurar la criptomoneda seleccionada con los datos de la API
         setSelectedCrypto({
            name: cryptoName,
            image: imagePath,
            qrCode: data.qrCode,
            address: data.address,
            currency: data.currency
         });

         // Ir directamente al paso 4 (modal de depósito de cripto)
         setInitialStep(4);
         setIsDepositModalOpen(true);

      } catch (error) {
         console.error('Error fetching deposit information:', error);
         // En caso de error, todavía mostrar el modal pero con información básica
         setSelectedCrypto({
            name: cryptoName,
            image: imagePath,
            error: error.message
         });
         setInitialStep(3); // Volver al selector de criptomonedas
         setIsDepositModalOpen(true);
      } finally {
         setIsLoading(false);
      }
   };

   const handleBuyClick = (cryptoName, imagePath, currencyCode) => {
      setSelectedCryptoForBuy({
         name: cryptoName,
         image: imagePath,
         currency: currencyCode
      });
      setIsBuyModalOpen(true);
   };

   const handleWithdrawClick = (e) => {
      e.preventDefault();
      // Asegurar que siempre empiece en el paso 1 (vista con las dos opciones)
      setWithdrawInitialStep(1);
      setIsWithdrawModalOpen(true);
   };

   // Agregar esta función al componente
   const handleSendCrypto = (cryptoName, imagePath, currency) => {
      setSelectedCryptoForWithdraw({
         name: cryptoName,
         image: imagePath,
         currency: currency
      });
      setIsSendModalOpen(true);
   };

   // Nueva función para manejar el retiro de USD
   const handleWithdrawUSDClick = () => {
      // Configurar para ir directamente al paso de retiro de USD
      setWithdrawInitialStep(2);
      // Configurar la moneda seleccionada para retirar
      setSelectedCryptoForWithdraw({
         name: 'US Dollar',
         image: '/assets/img/icon_dollar.svg',
         currency: 'USD',
         isUSD: true  // Agregamos esta bandera para indicar que es USD
      });
      // Abrir el modal de retiro
      setIsWithdrawModalOpen(true);
   };

   // Utilizar los balances de la API si están disponibles, de lo contrario usar los props
   const balancesToUse = !isLoading && Object.keys(apiBalances).length > 0 ? apiBalances : propBalances;

   // Para precio propt estable
   useEffect(() => {
      // La lógica de la API ahora vive aquí adentro
      const fetchRates = async () => {
         setIsLoading(true);
         try {
            const url = 'https://pt-api.digit-a.net/api/conversions';
            const response = await fetch(url);

            if (!response.ok) {
               throw new Error(`API Error: ${response.status}`);
            }

            const data = await response.json();
            setRates(data);
         } catch (error) {
            console.error("Could not load token prices.", error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchRates();
   }, []);

   const getPrice = (tokenName, currencySymbol = '$', decimals = 2) => {
      if (isLoading) return 'Loading...';
      if (!rates || typeof rates[tokenName] === 'undefined') {
         return 'Not Available';
      }
      if (tokenName === 'PROPT') {
         return `${currencySymbol}${rates[tokenName].toFixed(2)}`;
      }
      return `${currencySymbol}${rates[tokenName].toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
   };

   // Función para renderizar una caja de criptomoneda
   const renderCryptoBox = (currency, data, isStablecoin = false) => {
      const crypto = cryptoInfo[currency] || {
         name: currency,
         image: '/assets/img/icon_generic.svg',
         fullName: currency
      };

      const amount = data ? (typeof data.amount === 'string' ? parseFloat(data.amount) : data.amount) : 0;
      let rate;
      if (currency.startsWith('PROPT')) {
         rate = proptPrice;
      } else {
         rate = data?.rate || crypto.fixedPrice || 0;
      }
      const value = (amount * rate) || 0;

      return (
         <div className="col" key={currency}>
            <div className="ppt_box_gen">
               <div className="d-flex align-items-start gap-2 gap-lg-4 ppt_cryptoinfo flex-column flex-xl-row">
                  <div className='d-flex flex-column flex-lg-row gap-2 gap-lg-3 align-items-lg-start'>
                     <img src={process.env.PUBLIC_URL + crypto.image} alt={crypto.name} className='d-none d-lg-block' />
                     <div className="ppt_cryptoinfo_title mb-2">
                        <span className='d-flex align-items-center gap-2 mb-2'>
                           <img src={process.env.PUBLIC_URL + crypto.image} alt={crypto.name} className='d-lg-none' />
                           {crypto.name === "PROPT-POL" ? "PROPT-POLYGON" : crypto.name === "PROPT-ETH" ? "PROPT-ETHEREUM" : crypto.name}: {' '}
                           {amount.toFixed(currency === 'BTC' ? 8 : (currency === 'ETH' ? 6 : 2))}
                        </span>
                        {/* {<small>Last Price <em>${typeof rate === 'number' ?
                           (rate > 10 ? rate.toLocaleString('en-US') : rate.toFixed(rate < 1 ? 4 : 2)) :
                           '0.00'}</em></small>} */}
                        <small>Last Price <em>${
                           typeof rate === 'number'
                              ? currency.startsWith('PROPT')
                                 ? getPrice('PROPT', '')
                                 : (rate > 10
                                    ? rate.toLocaleString('en-US')
                                    : rate.toFixed(rate < 1 ? 4 : 2))
                              : '0.00'
                        }</em></small>
                        {/* {!isStablecoin && <small>Last 24hr <em className="text-danger">-0.54%</em></small>} */}
                        {/* {isStablecoin && <small>Price <em>$1.00</em></small>} */}
                        <small hidden>Amount <em>{amount.toFixed(currency === 'BTC' ? 8 : (currency === 'ETH' ? 6 : 2))} </em></small>
                        <small>Value <em>${value.toFixed(2)}</em></small>
                     </div>
                  </div>
                  <div className="d-flex flex-xl-column ms-auto ppt_crypto_actions gap-2 max-me w-100">
                     <span className="d-flex gap-2 mb-xl-2 w-1000">
                        <NavLink
                           style={{ fontSize: '14px' }}
                           className="w-100 mx-0 ppt_btn_primary alt active"
                           to="."
                           onClick={(e) => {
                              e.preventDefault();
                              // Llamar a handleCryptoDeposit con los parámetros correctos
                              handleCryptoDeposit(crypto.fullName, crypto.image, currency);
                           }}
                        >
                           Deposit
                        </NavLink>
                        <NavLink
                           style={{ fontSize: '14px' }}
                           className="w-100 mx-0 ppt_btn_secondary alt"
                           to="."
                           onClick={(e) => {
                              e.preventDefault();
                              handleSendCrypto(crypto.fullName, crypto.image, currency);
                           }}
                        >
                           Send
                        </NavLink>
                     </span>
                     <span className="d-flex gap-2 w-100">
                        <NavLink
                           style={{ fontSize: '14px' }}
                           // Cambiamos la condición para que incluya cualquier string que EMPIECE con "PROPT"
                           className={`w-100 mx-0 ppt_btn_primary alt bg-success text-white ${!currency.startsWith('PROPT') ? 'disabled' : ''}`}
                           to="."
                           onClick={(e) => {
                              e.preventDefault();
                              let apiCurrencyCode = 'PROPT'; // Por defecto, es PROPT (Ethereum)
                              if (crypto.fullName === 'ProperT (Polygon)') {
                                 apiCurrencyCode = 'PROPT_POLYGON';
                              }
                              console.log(crypto.fullName, apiCurrencyCode);
                              handleBuyClick(crypto.fullName, crypto.image, apiCurrencyCode);
                           }}
                        >
                           Buy
                        </NavLink>

                        <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white disabled" to=".">Sell</NavLink>
                     </span>
                  </div>
               </div>
            </div>
         </div>
      );
   };

   // Filtrar stablecoins y otras criptos
   const getStablecoins = () => {
      return walletData.filter(wallet =>
         ['USDC', 'USDT'].includes(wallet.currency)
      );
   };

   // const getOtherCryptos = () => {
   //    return walletData.filter(wallet =>
   //       ['BTC', 'ETH', 'MATIC', 'POL'].includes(wallet.currency)
   //       // ['BTC', 'ETH', 'MATIC', 'POL', 'PROPT'].includes(wallet.currency)
   //    )
   // };

   const supportedCryptoList = [
      'BTC',
      'ETH',
      'POL',
      'PROPT-ETH',
      'PROPT-POL',
   ];

   return (
      <>
         <div className="row mb-lg-5 flex-column-reverse pt-3">
            <div className="col col-lg-3">
               <div className="ppt_header d-flex justify-content-between align-items-center">
                  <nav className="ppt_navdash_scd">
                     <NavLink to="/dashboard" className="link active">Balances</NavLink>
                     <NavLink to="/activity" className="link">Activity</NavLink>
                     {/* <NavLink to="/exchange" className="link">Exchange</NavLink> */}
                     {/* <NavLink to="/deposit" className="link">Deposit</NavLink> */}
                     {/* <NavLink to="/withdrawal" className="link">Withdrawal</NavLink> */}
                  </nav>
               </div>
            </div>
            <div className="col-12 col-lg d-flex gap-3 justify-content-end ppt_account_actions_btns mb-4 mb-lg-0">
               <NavLink
                  className="ppt_btn_secondary d-flex align-items-center gap-2 justify-content-center"
                  to="."
                  onClick={handleWithdrawClick}
                  style={{ padding: '13px 18px', fontSize: '14px' }}
               >
                  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M5.5 13.5L5.5 1.5" stroke="#E4DC00" strokeWidth="2" strokeLinejoin="round" />
                     <path d="M10 5.5L5.5 1L1 5.5" stroke="#E4DC00" strokeWidth="2" strokeLinejoin="round" />
                  </svg>
                  Withdraw
               </NavLink>
               <NavLink
                  className="ppt_btn_secondary d-flex align-items-center gap-2 justify-content-center"
                  to="."
                  onClick={handleDepositClick}
                  style={{ padding: '13px 18px', fontSize: '14px' }}
               >
                  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M5.5 0V12" stroke="#E4DC00" strokeWidth="2" strokeLinejoin="round" />
                     <path d="M1 8L5.5 12.5L10 8" stroke="#E4DC00" strokeWidth="2" strokeLinejoin="round" />
                  </svg>
                  Deposit
               </NavLink>

            </div>
         </div>

         <div className="row mb-5">
            <div className="col-12 col-lg-auto pt-5 mb-4 mb-lg-0">
               <div className="ppt_box_gen sidebar h-100">
                  <div className="d-flex align-items-center flex-column gap-0 mb-2 mb-lg-0">
                     <span className='ppt_box_gensb_title'>Available Balance</span>
                     <span className='ppt_box_gensb_amount'>${totalBalance.toFixed(2)}</span>
                  </div>
                  <span className='ppt_box_gensb_graf mb-3 mb-lg-5'>
                     <svg width="215" height="215" viewBox="0 0 215 215" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_355_2)">
                           {/* Renderizar cada segmento del gráfico con el color correspondiente a la moneda */}
                           {(() => {
                              // Convertir porcentajes a segmentos de gráfico
                              let startAngle = -90; // Comenzar desde arriba
                              const center = { x: 107.508, y: 107.508 };
                              const radius = 107.508;
                              const segments = [];

                              // Solo procesar monedas con porcentaje > 0
                              const relevantPercentages = Object.entries(percentages)
                                 .filter(([_, percent]) => percent > 0)
                                 .sort((a, b) => b[1] - a[1]); // Ordenar de mayor a menor porcentaje

                              // Caso especial: una moneda con 100%
                              if (relevantPercentages.length === 1 && relevantPercentages[0][1] === 100) {
                                 const currency = relevantPercentages[0][0];
                                 return (
                                    <circle
                                       cx={center.x}
                                       cy={center.y}
                                       r={radius}
                                       fill={getCryptoColor(currency)}
                                    />
                                 );
                              }

                              // Caso especial: sin datos relevantes
                              if (relevantPercentages.length === 0) {
                                 return (
                                    <circle cx={center.x} cy={center.y} r={radius} fill="#e4e4e4" />
                                 );
                              }

                              // Caso normal: múltiples segmentos o un segmento < 100%
                              relevantPercentages.forEach(([currency, percent], index) => {
                                 const angle = (percent / 100) * 360;
                                 const endAngle = startAngle + angle;

                                 // Convertir ángulos a radianes
                                 const startRad = startAngle * (Math.PI / 180);
                                 const endRad = endAngle * (Math.PI / 180);

                                 // Calcular puntos
                                 const x1 = center.x + radius * Math.cos(startRad);
                                 const y1 = center.y + radius * Math.sin(startRad);
                                 const x2 = center.x + radius * Math.cos(endRad);
                                 const y2 = center.y + radius * Math.sin(endRad);

                                 // Determinar flag para arcos largos (> 180 grados)
                                 const largeArcFlag = angle > 180 ? 1 : 0;

                                 segments.push(
                                    <path
                                       key={currency}
                                       d={`M${center.x},${center.y} L${x1},${y1} A${radius},${radius} 0 ${largeArcFlag},1 ${x2},${y2} Z`}
                                       fill={getCryptoColor(currency)}
                                    />
                                 );

                                 // Actualizar ángulo inicial para el siguiente sector
                                 startAngle = endAngle;
                              });

                              return segments;
                           })()}
                        </g>
                        <defs>
                           <clipPath id="clip0_355_2">
                              <rect width="215" height="215" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                  </span>
                  <div className='ppt_box_gensb_list d-flex flex-lg-column gap-2 gap-lg-3 flex-wrap'>
                     {Object.entries(percentages).map(([currency, percent]) => (
                        <span key={currency} data-color={currency.toLowerCase()}>
                           <i style={{
                              display: 'inline-block',
                              width: '12px',
                              height: '12px',
                              borderRadius: '50%',
                              marginRight: '8px',
                              backgroundColor: getCryptoColor(currency)
                           }}></i>
                           {percent || 0}% {currency}
                        </span>
                     ))}
                  </div>
               </div>
            </div>
            <div className="col">
               <div className="row mb-5 mx-auto max">
                  <div className="col px-0 px-lg-3">
                     <h3 className="ppt_form_title mb-3">Balances</h3>
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-center gap-4 ppt_cryptoinfo justify-content-between">
                           <span className="d-flex align-items-center gap-2 gap-lg-4">
                              <img src={process.env.PUBLIC_URL + '/assets/img/icon_dollar.svg'} data-lightmodeimg alt="" />
                              <div className="ppt_cryptoinfo_title">
                                 <span>US Dollar</span>
                                 <em>${(balancesToUse.USD || 0).toFixed(2)}</em>
                              </div>
                           </span>
                           <div className="ppt_cryptoinfo_name w-100" style={{ maxWidth: '420px' }}>
                              <small>$1 USD = {getPrice('PROPT')} PROPT = $1 USD</small>
                              <small>Use them interchangeably on the ProperT platform and withdraw funds anytime as any of these assets.</small>
                           </div>
                           <div className="ppt_cryptoinfo_actions">
                              <NavLink
                                 to="."
                                 className="ppt_btn_primary ms-auto alt"
                                 onClick={(e) => {
                                    e.preventDefault();
                                    handleDepositUSDClick();
                                 }}
                              >
                                 Deposit USD
                              </NavLink>
                              <NavLink
                                 to="."
                                 className="ppt_btn_secondary ms-auto alt"
                                 onClick={(e) => {
                                    e.preventDefault();
                                    handleWithdrawUSDClick();
                                 }}
                              >
                                 Withdraw USD
                              </NavLink>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>



               {/* Sección de criptomonedas - Generada dinámicamente */}
               <div className="row mx-auto max">


                  <div className="col-12 px-0 px-lg-3">
                     <h3 className="ppt_form_title mb-3">Stablecoins Balance</h3>
                  </div>

                  {/* Renderizar dinámicamente las cajas de criptomonedas */}
                  {getStablecoins().map((wallet, index) => (
                     <div className="col-12 col-lg-6 mb-4 px-0 px-lg-3" key={wallet.currency}>
                        {renderCryptoBox(wallet.currency, wallet, true)}
                     </div>
                  ))}


                  <div className="col-12 px-0 px-lg-3">
                     <h3 className="ppt_form_title mb-3">Supported Crypto</h3>
                  </div>

                  {supportedCryptoList.map((currencyName) => {
                     const wallet = walletData.find(w => w.currency === currencyName) || { currency: currencyName, amount: 0 };
                     return (
                        <div className="col-12 col-lg-6 mb-4 px-0 px-lg-3" key={currencyName}>
                           {renderCryptoBox(currencyName, wallet)}
                        </div>
                     );
                  })}


               </div>
            </div>
         </div>

         <DepositModal
            isOpen={isDepositModalOpen}
            onClose={() => {
               setIsDepositModalOpen(false);
               setInitialStep(1);
               setSelectedCrypto(null);
            }}
            initialStep={initialStep}
            initialCrypto={selectedCrypto}
         />
         <BuyModal
            isOpen={isBuyModalOpen}
            onClose={() => {
               setIsBuyModalOpen(false);
               setSelectedCryptoForBuy(null);
            }}
            cryptoType={selectedCryptoForBuy}
            totalBalance={(balancesToUse.USD || 0)}
            walletData={walletData}
         />
         <WithdrawModal
            isOpen={isWithdrawModalOpen}
            onClose={() => {
               setIsWithdrawModalOpen(false);
               setWithdrawInitialStep(1);
               setSelectedCryptoForWithdraw(null);
            }}
            initialStep={withdrawInitialStep}
            initialCrypto={selectedCryptoForWithdraw}
            directSend={selectedCryptoForWithdraw?.isSendOperation || false}
            skipToSend={selectedCryptoForWithdraw?.isSendOperation || false}
            goToWithdrawUSD={selectedCryptoForWithdraw?.isUSD || false} // Nueva prop para indicar retiro de USD
            key={`withdraw-modal-${isWithdrawModalOpen}-${selectedCryptoForWithdraw?.currency || 'none'}-${withdrawInitialStep}`}
         />
         <SendCryptoModal
            isOpen={isSendModalOpen}
            onClose={() => {
               setIsSendModalOpen(false);
               setSelectedCryptoForWithdraw(null);
            }}
            initialCrypto={selectedCryptoForWithdraw}
         />

         {/* Temporalmente, para pruebas */}
         {/* <div>
            <button onClick={() => { setWithdrawInitialStep(1); setIsWithdrawModalOpen(true); }}>Paso 1</button>
            <button onClick={() => { setWithdrawInitialStep(2); setIsWithdrawModalOpen(true); }}>Paso 2</button>
            <button onClick={() => { setWithdrawInitialStep(3); setIsWithdrawModalOpen(true); }}>Paso 3</button>
            <button onClick={() => { setWithdrawInitialStep(4); setIsWithdrawModalOpen(true); }}>Paso 4</button>
         </div> */}
      </>
   );
};

export default DashboardValidated;
// deposit de cuenta corriente en dolares